// Couleurs des prestations, alignées sur celles de l'agenda (GoogleCalendarColorSelector).
// L'agenda regroupe « Stage 1/2/3 » sous une seule teinte : on la garde pour le stage 1
// et on la décline pour les stages 2 et 3, qui sont ici des séries distinctes.
export const SERVICE_COLORS = {
    'reprogrammation stage 0': '#3F51B5', // Stage 0
    'reprogrammation stage 1': '#039BE5', // Stage 1/2/3
    'reprogrammation stage 2': '#0277BD',
    'reprogrammation stage 3': '#01579B',
    'conversion e85': '#33B679',          // FlexFuel
    'conversion e85+': '#F4511E',         // FlexFuel+
    'entretien': '#F6BF26',               // Mécanique
    'esthétique': '#616161',              // Esthétique
    'passage au banc': '#8E24AA',         // Passage au banc
    'remise origine': '#7B3F00',          // Remise Origine
    'sav': '#D50000',                     // SAV
    // Prestations absentes de la palette agenda : teintes distinctes des précédentes.
    'pièces performance': '#D81B60',
    'boîte de vitesses': '#00897B',
    'gearbox': '#00897B',
    'diagnostic': '#546E7A',
    'tournage vidéo': '#C0CA33',
}
export const OTHER_SERVICE_COLOR = '#9E9E9E'
export const FALLBACK_SERVICE_COLORS = ['#6D4C41', '#26A69A', '#EC407A', '#5C6BC0', '#FF7043']

export const serviceColor = (nom, index) => {
    if (nom === 'Autres') return OTHER_SERVICE_COLOR
    return SERVICE_COLORS[nom.trim().toLowerCase()] ?? FALLBACK_SERVICE_COLORS[index % FALLBACK_SERVICE_COLORS.length]
}
